export default __webpack_public_path__ + "0b7ad37eac63107aeb707520cf10b767.png";